import { SupabaseClient } from '@supabase/supabase-js';
import { useQueryWithErrorBoundary, useSupabaseTypedClient } from 'hooks/reactQuery';

import { TanstackQueryName } from 'types/frontend';
import { Database } from 'types/supabase';

interface IGetRoastUserVoteQueryFnParams {
  supabase: SupabaseClient<Database>;
  roastId: string;
  userId: string;
}

const getRoastUserVoteQueryFn = async ({
  supabase,
  roastId,
  userId,
}: IGetRoastUserVoteQueryFnParams): Promise<boolean> => {
  const { data, error } = await supabase
    .from('roast_vote')
    .select('id')
    .eq('roast_id', roastId)
    .eq('user_id', userId)
    .maybeSingle();

  if (error) throw error;

  return data !== null;
};

interface IGetRoastUserVoteQueryParams {
  roastId?: string | null;
  userId?: string | null;
}

interface IGetRoastUserVoteQueryResponse {
  hasVoted: boolean;
  isPending: boolean;
}

export const useGetRoastUserVoteQuery = ({
  roastId,
  userId,
}: IGetRoastUserVoteQueryParams): IGetRoastUserVoteQueryResponse => {
  const supabase = useSupabaseTypedClient();

  const { data, isPending } = useQueryWithErrorBoundary({
    queryKey: [TanstackQueryName.GetRoastUserVote, roastId, userId],
    queryFn: () =>
      getRoastUserVoteQueryFn({
        supabase,
        roastId: roastId!,
        userId: userId!,
      }),
    enabled: Boolean(roastId) && Boolean(userId),
  });

  return {
    hasVoted: data ?? false,
    isPending,
  };
};
